// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guest-item[data-v-5229d640]{cursor:pointer}.guest-item[data-v-5229d640]:hover{background:#0d47a1;color:#fff}.guest-status-image[data-v-5229d640]{width:21px;height:21px}.accept-button[data-v-5229d640]{margin-left:5px}", ""]);
// Exports
module.exports = exports;
